import { gql } from '@apollo/client';

export const CREATE_RECEIVE_EXCEPTION = gql`
  mutation createReceiveException($request: CreateReceiveExceptionRequest) {
    createReceiveException(request: $request)
  }
`;

export const UPDATE_RECEIVE_EXCEPTION = gql`
  mutation updateReceiveException($request: UpdateReceiveExceptionRequest) {
    updateReceiveException(request: $request) {
      id
      exceptionId
      title
      version
      exceptionType
      locationId
      site
      quantity
      shipmentReferenceId
      orderType
      orderNumber
      trackingNumber
      holdingLocation
      model
      legacyModelId
      serials
      orderLineNumber
      tags
      status
      assignedToId
      assignedToType
      resolver
      resolutionCode
      resolutionNote
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;

export const GET_RECEIVE_EXCEPTION = gql`
  query getReceiveException($exceptionId: String!) {
    getReceiveException(exceptionId: $exceptionId) {
      id
      exceptionId
      title
      version
      exceptionType
      site
      quantity
      shipmentReferenceId
      orderType
      orderNumber
      trackingNumber
      holdingLocation
      model
      legacyModelId
      serials
      orderLineNumber
      tags
      status
      assignedToId
      assignedToType
      resolver
      resolutionCode
      resolutionNote
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;

export const LIST_EXCEPTION_NOTES = gql`
  query listReceiveExceptionNotes($request: ListReceiveExceptionNotesRequest) {
    listReceiveExceptionNotes(request: $request) {
      notes {
        id
        note
        createdAt
        createdBy {
          contact
        }
      }
      nextToken
    }
  }
`;

export const CREATE_EXCEPTION_NOTE = gql`
  mutation createReceiveExceptionNote($request: CreateReceiveExceptionNoteRequest) {
    createReceiveExceptionNote(request: $request) {
      id
      note
      createdAt
      createdBy {
        contact
      }
    }
  }
`;

export const SEARCH_RECEIVE_EXCEPTIONS = gql`
  query searchReceiveExceptions($request: SearchReceiveExceptionRequest) {
    searchReceiveExceptions(request: $request) {
      searchResults {
        id
        exceptionId
        title
        version
        exceptionType
        locationId
        site
        quantity
        shipmentReferenceId
        orderType
        orderNumber
        trackingNumber
        holdingLocation
        model
        legacyModelId
        serials
        orderLineNumber
        tags
        status
        assignedToId
        assignedToType
        resolver
        resolutionCode
        resolutionNote
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
      totalHits
    }
  }
`;

export const GET_RESOLVER_CONFIG = gql`
  query getResolverConfig {
    getReceiveExceptionResolverConfig {
      config
    }
  }
`;
